import { toast } from "sonner"
import React from "react"
import { WingsHeading, WingsIcon, WingsDetailText } from "@wingspans-ui"
import "./toasts.css"

/**
 * used for error messages and generic toast notifications that arent part of the users notification drawer
 * @param { JSX } content - the content of the toast, can be JSX for custom content
 * @param { string } message - the message to display in the toast
 * @param { string } heading - the heading to display in the toast
 *  */
export const sendStandardToast = ({ message, heading, type = "error" }) => {
  toast(<StandardToast heading={heading} message={message} type={type} />, {
    position: "top-right",
    closeButton: true,
    duration: 120000,
    style: {
      marginTop: "1rem",
      padding: "0",
    },
  })
}

const StandardToast = ({ message, heading, type = "error" }) => {
  const colors = {
    error: "var(--w-color-red-600)",
    warning: "var(--w-color-orange-500)",
    success: "#3DCC91",
  }

  const icons = {
    error: "exclamation",
    warning: "exclamation",
    success: "check",
  }

  if (!colors[type]) {
    type = "error"
  }

  return (
    <div className={`notifications-toast-item notifications-toast-item-standard notifications-toast-item-standard--${type} w-p-1`}>
      <div className={`notifications-toast-item-standard-icon w-self-start ${type}`}>
        <div>
          <WingsIcon icon={icons[type]} color={colors[type]} size="large" className="w-m-0" />
        </div>
      </div>
      <div className="notifications-toast-item-standard-message">
        <label className="notifications-toast-item-standard-title is-error">
          <WingsHeading level={6} underlineColor={colors[type]}>
            {heading}
          </WingsHeading>
        </label>
        <WingsDetailText className="notifications-toast-item-standard-body">
          {message}
        </WingsDetailText>
      </div>
    </div>
  )
}
